import { MNSproCloudApi } from '../..';
import { MethodOfTeachingResponse } from '../../api/v2/api';
import { MethodOfTeaching } from './classbookSettings.interfaces';

export class ClassbookMethodOfTeachingService {
  static async getMethodOfTeaching(
    authToken: string,
    organizationId: string,
  ): Promise<MethodOfTeachingResponse[]> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ClassRegisterApiFactory(config);

    const result = await api.getAllMethodsOfTeaching(organizationId);

    return result.data;
  }

  static async createMethodOfTeaching(
    authToken: string,
    organizationId: string,
    name?: string | null,
    description?: string | null,
    isDisabled?: boolean,
  ): Promise<void> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ClassRegisterApiFactory(config);
    await api.createMethodOfTeaching(organizationId, {
      name,
      description,
      isDisabled,
    });
  }

  static async updateMethodOfTeaching(
    authToken: string,
    organizationId: string,
    id?: string,
    name?: string | null,
    description?: string | null,
    isDisabled?: boolean,
  ): Promise<void> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ClassRegisterApiFactory(config);
    await api.updateMethodOfTeaching(organizationId, {
      id,
      name,
      description,
      isDisabled,
    });
  }

  static async deleteMethodOfTeaching(
    authToken: string,
    organizationId: string,
    id: string,
  ): Promise<void> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ClassRegisterApiFactory(config);
    await api.deleteMethodOfTeaching(id, organizationId);
  }
}
